export function getScrollTop() {
  return window.pageYOffset
    ? window.pageYOffset
    : document.documentElement.clientHeight
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
}
